import { useEffect } from 'react';
import type { StatusBarSurface } from '../lib/statusBarStyle';
import { useStatusBarSurfaceStore } from '../stores/statusBarSurfaceStore';

/**
 * Declare what this page paints under the native status bar (PD-16744).
 *
 * A page that renders without the brand header band must call this with
 * `'page'`; otherwise the status bar keeps the header's text color, which is
 * white on most brands and disappears on a light page. The claim lasts while
 * the page is mounted, follows changes to `surface`, and leaving the page
 * releases only this claim, so the header-derived style comes back on its own.
 *
 * Call it unconditionally, before any early return.
 */
export function useStatusBarSurface(surface: StatusBarSurface): void {
	const claim = useStatusBarSurfaceStore((s) => s.claim);
	const release = useStatusBarSurfaceStore((s) => s.release);

	useEffect(() => {
		const id = claim(surface);
		return () => {
			release(id);
		};
	}, [surface, claim, release]);
}
